export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  selectedSpecificMembers: { borderBottomRightRadius: '0px', borderBottomLeftRadius: '0px' },
};
